<div class="layout-footer">
    <div class="footer-logo-container">
    </div>
    <app-versions #versionsComponent></app-versions>
    <span class="copyright">&#169; Ingeniería Gallega de Software SL - {{currentYear}}
        <a class="button"
            (click)=openVersions()>v{{currentApplicationVersion}}</a></span>
</div>